<template>
  <Modal v-model="visible" :width="520" class-name="save-template-modal" :closable="false" :mask-closable="false" footer-hide>
    <div class="save-tpl-head">
      <Icon type="ios-save" class="save-tpl-icon" />
      <span class="save-tpl-title">保存为查询模版</span>
    </div>
    <Form ref="tplForm" :model="form" :rules="rules" :label-width="0">
      <FormItem prop="name">
        <div class="save-tpl-label">模版名称 <span class="required">*</span></div>
        <Input v-model="form.name" maxlength="50" placeholder="请输入模版名称，如：2024年度财务凭证查询" />
      </FormItem>
      <FormItem prop="remark">
        <div class="save-tpl-label">模版描述</div>
        <Input v-model="form.remark" type="textarea" :rows="8" maxlength="200" placeholder="请简要描述查询模版用途、能力" />
      </FormItem>
    </Form>
    <div class="save-tpl-footer">
      <Button @click="onCancel">取消</Button>
      <Button type="success" :loading="saving" @click="onConfirm">确认保存</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  name: 'save-template-modal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    api: {
      type: Object,
      required: true
    },
    // 待保存的查询配置
    payload: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      visible: this.value,
      saving: false,
      form: {
        name: '',
        remark: ''
      },
      rules: {
        name: [{ required: true, message: '请输入模版名称', trigger: 'blur' }]
      }
    }
  },
  watch: {
    value(val) {
      this.visible = val
      if (val) {
        this.form.remark = ''
        this.$nextTick(() => {
          // 先重置清空校验，再带出配置页的模板名称（默认当前日期）
          this.$refs.tplForm && this.$refs.tplForm.resetFields()
          this.form.name = this.payload && this.payload.templateName ? this.payload.templateName : ''
          this.form.remark = this.payload && this.payload.remark ? this.payload.remark : ''

        })
      }
    },
    visible(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    onCancel() {
      this.visible = false
    },
    onConfirm() {
      this.$refs.tplForm.validate(valid => {
        if (!valid) {
          return
        }
        this.saving = true
        this.api
          .saveQueryTemplate({
            appId: this.payload.appId,
            id: this.payload.id || '',
            templateName: this.form.name,
            remark: this.form.remark,
            // 查询条件拼接的中文内容
            queryCondition: this.payload.queryCondition || '',
            queryJson: this.payload.queryJson
          })
          .then(resp => {
            this.saving = false
            if (resp && resp.success) {
              this.$Message.success('保存成功')
              this.visible = false
              this.$emit('saved', resp)
            } else {
              this.$Message.error((resp && resp.msg) || '保存失败')
            }
          })
          .catch(() => {
            this.saving = false
            this.$Message.error('保存失败')
          })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.save-tpl-head {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
}
.save-tpl-icon {
  font-size: 24px;
  color: #2b5fd9;
  margin-right: 8px;
}
.save-tpl-title {
  font-size: 20px;
  font-weight: 600;
}
.save-tpl-label {
  font-size: 14px;
  margin-bottom: 6px;
  color: #333;
}
.save-tpl-label .required {
  color: #ed4014;
}
.save-tpl-footer {
  text-align: right;
  margin-top: 10px;
}
.save-tpl-footer button {
  min-width: 88px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/component/data-grid/custom-query/components/save-template-modal.vue